import React from 'react'
import { reduxForm, Field } from 'redux-form'

import classNames from './common.css'
import Modal from './Modal'
import ConfirmButtons from '../ConfirmButtons'
import LoadingSpinner from '../LoadingSpinner'

function FlagImageModal ({ handleSubmit, submitting, closeModal }) {
  return (
    <Modal title='Flag Image' onClose={closeModal}>
      <form className={classNames.form}>
        <label>
          Reason (optional)
          <Field
            component={ReasonInput}
            name='reason'
            placeholder='Enter a reason for flagging this image'
            autoFocus
          />
        </label>
        <ConfirmButtons
          onCancel={closeModal}
          onConfirm={handleSubmit}
          confirmText='Flag Image'
          confirmDisabled={submitting}
        />
        <LoadingSpinner show={submitting} />
      </form>
    </Modal>
  )
}

function ReasonInput ({ value, onChange }) {
  const onClickButton = e => {
    onChange(value + e.target.value + '\n')
    e.target.parentNode.querySelector('textarea').focus()
  }
  const Button = ({ value }) => (
    <button
      type='button'
      onClick={onClickButton}
      className={classNames.smallButton}
      value={value}>
        {value}
    </button>
  )
  return (
    <div>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <Button value='noupload' />
      <Button value='orientation' />
      <Button value='album path' />
      <Button value='keywords' />
    </div>
  )
}

export default reduxForm({ form: 'flagImage' })(FlagImageModal)



// WEBPACK FOOTER //
// ./src/components/modals/FlagImageModal.js